import { Inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IExtendedWindow, IObject } from '../../../type_definitions/datatypes';

const HTTP_HEADER_VERSION:string = 'X-GA-Client-Version';
const HTTP_HEADER_LOCATION:string = 'X-GA-Client-URL';
const HTTP_HEADER_CONTENT_TYPE:string = 'Content-Type';

@Injectable()
export class HttpHeadersInterceptor implements HttpInterceptor {

  constructor(
    @Inject(Window) private window:IExtendedWindow
  ) {
    /**/
  }

  public intercept(req:HttpRequest<any>, next:HttpHandler):Observable<HttpEvent<any>> {
    const locations:string[] = [this.window.location.href];
    let topLocation:string;
    try {
      topLocation = this.window.top.location.href;
    } catch (e) {
      // we ignore this, probably an origin error
    }
    if (topLocation && topLocation !== locations[ 0 ]) {
      locations.push(topLocation);
    }

    const headers:IObject = {
      [ HTTP_HEADER_VERSION ]: 'GA2-2.0.23716-16858',
      [ HTTP_HEADER_LOCATION ]: locations
    };

    // if header content-type is undefined then set default
    if (!req.headers.has(HTTP_HEADER_CONTENT_TYPE)) {
      // angular default content-type is 'text/plain'
      headers[HTTP_HEADER_CONTENT_TYPE] = 'application/json;charset=UTF-8';
    }

    return next.handle(req.clone({ setHeaders: headers }));
  }
}